export default __webpack_public_path__ + "static/media/access-denied.61942693.svg";